import React from 'react';
import PropTypes from 'prop-types';
import Input from 'widgets/Input';
import Icon from 'components/Icon';
import colors from 'assets/styles/jsVariables/colors';
import './LabelledSelect.scss';

const styles = {
  chevronIconStyle: {
    width: 12,
    height: 12
  },
  chevronIconColor: colors.lighterCyan,
  chevronIconUp: 'chevron-up',
  chevronIconDown: 'chevron-down'
};

export default class LabelledSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false
    };
  }
  handleMenuOpen = () => {
    this.setState({ isMenuOpen: true });
  }

  handleMenuClose = () => {
    this.setState({ isMenuOpen: false });
  }

  ChevronUp = () => (
    <Icon
      style={this.props.chevronIconStyle}
      fill={this.props.isError ? colors.carrotRed : this.props.chevronIconColor}
      name={this.props.chevronIconUp}
    />
  );

  ChevronDown = () => (
    <Icon
      style={this.props.chevronIconStyle}
      fill={this.props.isError ? colors.carrotRed : this.props.chevronIconColor}
      name={this.props.chevronIconDown}
    />
  );

  render() {
    const {
      isError, name, labelText, value, onChange, iconName,
      type, errorText, autoFocus, errorStyle, children,
      placeholder, options, isDisabled
    } = this.props;

    const { isMenuOpen } = this.state;

    const _options = options.map((option) => {
      const _label = Object.keys(option)[0];
      const _value = option[_label];
      return (
        { value: _value, label: _label }
      );
    });

    const fieldValue = value.label ? value : '';

    return (
      <React.Fragment>
        <div className="LabelledSelect__Label">
          {
            iconName &&
            <Icon
              name={iconName}
            />
          }
          <span className="LabelledSelect__Label__Text">
            {labelText}
          </span>
        </div>
        <Input
          className={isError ? 'LabelledSelect__Input--Error' : 'LabelledSelect__Input'}
          name={name}
          placeholder={placeholder}
          onChange={(_value) => {
            const e = {
              target: {
                name,
                value: _value
              }
            };
            onChange(e);
          }}
          value={fieldValue}
          type={type}
          autoFocus={autoFocus}
          selectProps={{
            options: _options,
            classNamePrefix: 'react-select',
            onMenuOpen: this.handleMenuOpen,
            onMenuClose: this.handleMenuClose,
            isDisabled,
            components: {
              DropdownIndicator: isMenuOpen ? this.ChevronUp : this.ChevronDown,
            }
          }}
        >
          {
            children
          }
        </Input>
        <div className="LabelledSelect__ValidationMsg" style={errorStyle}>
          {
            errorText
          }
        </div>
      </React.Fragment>
    );
  }
}

LabelledSelect.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array, PropTypes.string]),
  onChange: PropTypes.func.isRequired,
  isError: PropTypes.bool.isRequired,
  autoFocus: PropTypes.bool,
  name: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  labelText: PropTypes.string.isRequired,
  value: PropTypes.object.isRequired,
  options: PropTypes.array,
  type: PropTypes.string,
  errorText: PropTypes.string,
  errorStyle: PropTypes.object,
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
  chevronIconStyle: PropTypes.object,
  chevronIconColor: PropTypes.string,
  chevronIconUp: PropTypes.string,
  chevronIconDown: PropTypes.string
};

LabelledSelect.defaultProps = {
  iconName: '',
  children: '',
  errorText: '',
  type: 'default',
  autoFocus: false,
  errorStyle: {},
  placeholder: '',
  options: [],
  isDisabled: false,
  chevronIconStyle: styles.chevronIconStyle,
  chevronIconColor: styles.chevronIconColor,
  chevronIconUp: styles.chevronIconUp,
  chevronIconDown: styles.chevronIconDown
};



// WEBPACK FOOTER //
// ./src/components/LabelledSelect/LabelledSelect.jsx